<template>
  <b-modal
    title="EDITAR CATEGORIA"
    no-close-on-backdrop
    hide-footer
    id="modify_category"
    @shown="evOnShow"
  >
    <b-overlay :show="loading" opacity="0.99">
      <b-form @submit.prevent="updateCategory">
        <div class="form-section">
          <div class="section-header">
            <h4 class="section-title">
              <i class="fas fa-layer-group mr-2"></i>
              Informações Importantes
            </h4>
          </div>

          <div class="section-content">
            <b-row>
              <b-col>
                <label-required-field label="Nome da Categoria" />
                <b-input
                  :disabled="!editable || errors.length > 0"
                  type="text"
                  v-model="category.name"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <label-required-field
                  label="Obrigatório assinatura com certificado?"
                />
                <select
                  v-model="category.required_certificate"
                  class="form-control"
                >
                  <option value="0">NÃO</option>
                  <option value="1">SIM</option>
                </select>
              </b-col>
            </b-row>

            <label-required-field label="Tipo de visualização da Categoria" />

            <div class="toggle-group">
              <button
                type="button"
                :class="['toggle-btn', { active: category.public == 1 }]"
                @click="category.public = 1"
              >
                <i class="fas fa-user mr-2"></i>

                <span>Pública</span>
              </button>

              <button
                type="button"
                :class="['toggle-btn', { active: category.public == 0 }]"
                @click="category.public = 0"
              >
                <i class="fas fa-users mr-2"></i>

                <span>Perfil</span>
              </button>
            </div>
          </div>
        </div>

        <div v-if="category.public == 0" class="form-section">
          <div class="section-header">
            <h4 class="section-title">
              <i class="fas fa-user-check mr-2"></i>
              Controle de Acesso por Perfil de Usuário
            </h4>
          </div>
          <div class="section-content">
            <div class="form-group">
              <LabelRequiredField label="Perfis com Acesso" />

              <div class="select-wrapper">
                <v-select
                  v-model="profiles_ids"
                  :items="profiles"
                  item-text="name"
                  item-value="id"
                  multiple
                  clearable
                  ref="profileSelect"
                  outlined
                  hide-details
                  class="modern-select"
                  placeholder="Selecione os perfis"
                  @change="closeSelectProfile"
                />
              </div>
            </div>
          </div>
        </div>

        <errors-messages :errors="errors" />

        <b-row align-h="between">
          <b-col cols="auto">
            <v-btn
              class="btn-cancel m-1"
              @click="$bvModal.hide('modify_category')"
            >
              CANCELAR
            </v-btn>
          </b-col>

          <b-col cols="auto">
            <v-btn v-if="editable" type="submit" class="btn-save m-1">
              <i class="fas fa-save mr-2 text-twenty"></i>
              SALVAR
            </v-btn>
          </b-col>
        </b-row>
      </b-form>
    </b-overlay>
  </b-modal>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages.vue";

import LabelRequiredField from "../Components/LabelRequiredField";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

export default {
  name: "ModifyCategory",

  components: {
    ErrorsMessages,
    LabelRequiredField,
  },

  props: {
    form_id: [String, Number],

    category_id: [String, Number],

    editable: Boolean,
  },

  data() {
    return {
      category: [],

      profiles: [],

      profiles_ids: [],

      errors: [],

      loading: false,
    };
  },

  methods: {
    async getCategory() {
      try {
        this.loading = true;

        const { form_id, category_id } = this;

        let params = {
          form_id,
          category_id,
        };

        let response = await api.get("/rest-home/semiology/form/category", {
          params,
        });

        let { error, errors, category } = response.data;

        if (!error) {
          this.category = category;

          if (category.profiles) {
            this.profiles_ids = category.profiles.map(
              (profile) => profile.profile_id
            );
          }
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    async getProfiles() {
      try {
        this.loading = true;

        const { form_id, category_id } = this;

        let params = {
          form_id,
          category_id,
        };

        const response = await api.get("/rest-home/semiology/form/profile", {
          params,
        });

        const { error, errors, profiles } = response.data;

        if (!error) {
          this.profiles = profiles;
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.error(error);
      }
    },

    async updateCategory() {
      try {
        this.loading = true;

        const { form_id, category_id, profiles_ids } = this;

        const name = this.category.name;
        const required_certificate = this.category.required_certificate;

        const public_category = this.category.public;

        let data = {
          form_id,
          category_id,
          name,
          required_certificate,
          public_category,
          profiles_ids,
        };

        let response = await api.patch(
          "/rest-home/semiology/form/category",
          data
        );

        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.$emit("updated");

          toast(message, "success");

          this.$bvModal.hide("modify_category");
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    async evOnShow() {
      this.errors = [];

      this.loading = false;

      this.category = [];

      await this.getProfiles();

      await this.getCategory();
    },

    closeSelectProfile() {
      this.$refs.profileSelect.blur();
    },
  },
};
</script>

<style escoped>
.form-section {
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
  transition: all 0.3s ease;
  margin-bottom: 20px;
}

.form-section:hover {
  border-color: #cbd5e1;
}

.section-header {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.section-title i {
  color: #0f65b0;
  font-size: 14px;
}

.section-content {
  padding: 20px;
}

/* Toggle Buttons */
.toggle-group {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

.toggle-btn {
  display: flex;
  align-items: center;
  background: white;
  color: #6b7280;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  padding: 14px 24px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 140px;
  justify-content: center;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.toggle-btn:hover:not(.active) {
  background: #f8fafc;
  border-color: #cbd5e1;
  color: #374151;
  transform: translateY(-1px);
}

.toggle-btn.active {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  color: white;
  border-color: #0f65b0;
  box-shadow: 0 4px 15px rgba(15, 101, 176, 0.3);
}

.toggle-btn i {
  font-size: 16px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.select-wrapper {
  position: relative;
}

/* Modern Select (v-select) */
.modern-select >>> .v-input__control {
  border-radius: 8px !important;
}

.modern-select >>> .v-text-field__slot {
  background: white !important;
}

.modern-select >>> .v-input__slot {
  border: 2px solid #e5e7eb !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
}

.modern-select >>> .v-input__slot:hover {
  border-color: #cbd5e1 !important;
}

.modern-select >>> .v-input--is-focused .v-input__slot {
  border-color: #0f65b0 !important;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1) !important;
}

.modern-select >>> .v-select__selection {
  color: #1e293b !important;
  font-weight: 500 !important;
}

/* Form Hint */
.form-hint {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #6b7280;
  margin-top: 4px;
  font-style: italic;
}

.form-hint i {
  color: #94a3b8;
  font-size: 11px;
}
</style>